module.exports = __webpack_public_path__ + "static/media/poste_4.5979bb70.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/poste_4.jpg
// module id = 261
// module chunks = 0